import { useEffect, useState, useRef } from 'react';
import you from '../../assets/images/boy.png'

import bot from '../../assets/images/happy.png'; 
import Mainmenu from './MainMenu';

function Frame1() {
  const [name, setName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');

  const [showMobileFrame, setShowMobileFrame] = useState(false);
  const [showEmailFrame, setShowEmailFrame] = useState(false);
  const [showSuccessFrame, setShowSuccessFrame] = useState(false);

  const [showNameInput, setShowNameInput] = useState(true);
  const [showMobileInput, setShowMobileInput] = useState(false);
  const [showEmailInput, setShowEmailInput] = useState(false);

  const [nameTime, setNameTime] = useState(null);
  const [mobileTime, setMobileTime] = useState(null);
  const [emailTime, setEmailTime] = useState(null);

  const nameRef = useRef(null);
  const mobileRef = useRef(null);
  const emailRef = useRef(null);

  useEffect(() => {
    nameRef.current?.focus();
  }, []);

  useEffect(() => {
    if (showMobileInput) {
      mobileRef.current?.focus();
    }
  }, [showMobileInput]);

  useEffect(() => {
    if (showEmailInput) {
      emailRef.current?.focus();
    }
  }, [showEmailInput]);

  const handleNameChange = (e) => {
    const value = e.target.value;
    if (/^[A-Za-z\s]*$/.test(value)) {
      setName(value);
    }
  };

  const handleNameSubmit = () => {
    if (name.trim().length === 0) {
      alert('Please enter your name');
      return;
    }
    setNameTime(new Date());
    setShowNameInput(false);
    setShowMobileFrame(true);
    setShowMobileInput(true);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value) && value.length <= 10) {
      setMobileNumber(value);
    }
  };

  const handleMobileSubmit = () => {
    if (mobileNumber.length !== 10) {
      alert('Phone number must be exactly 10 digits');
      return;
    }
    setMobileTime(new Date());
    setShowMobileInput(false);
    setShowEmailFrame(true);
    setShowEmailInput(true);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleEmailSubmit = () => {
    if (!email.includes('@') || !email.includes('.')) {
      alert('Please enter a valid email address');
      return;
    }
    setEmailTime(new Date());
    setShowEmailInput(false);
    setShowSuccessFrame(true);
  };

  const handleKeyDown = (e, callback) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      callback();
    }
  };

  return (
    <>
      <div className="frame1 animated-frame">
        May I know your name?
        {showNameInput && (
          <div className="message fade-in">
            <input
              type="text"
              placeholder="Enter your name"
              className="input-text2"
              value={name}
              onChange={handleNameChange}
              onKeyDown={(e) => handleKeyDown(e, handleNameSubmit)}
              ref={nameRef}
            />
            <button className="submit-button" onClick={handleNameSubmit}></button>
          </div>
        )}
      </div>

      {showMobileFrame && (
        <>
          <div className="you-time animated-frame">
            <img src={you} alt="you" className="boy" />
            <div className="chatbot-time">{nameTime?.toLocaleTimeString()}</div>
          </div>
          <div className="you-message fade-in">
            <div className="frame2 animated-frame"><b>{name}</b></div>
          </div>
          <div className="chatbot animated-frame">
            <img src={bot} alt="bot" className="bot" />
            <div className="chatbot-time">{nameTime?.toLocaleTimeString()}</div>
          </div>

          <div className="frame1 animated-frame">
            Kindly share your mobile number
            {showMobileInput && (
              <div className="message fade-in">
                <input
                  type="text"
                  placeholder="Enter your mobile number"
                  className="input-text2"
                  value={mobileNumber}
                  onChange={handleMobileChange}
                  onKeyDown={(e) => handleKeyDown(e, handleMobileSubmit)}
                  ref={mobileRef}
                />
                <button className="submit-button" onClick={handleMobileSubmit}></button>
              </div>
            )}
          </div>
        </>
      )}

      {showEmailFrame && (
        <>
          <div className="you-time animated-frame">
            <img src={you} alt="you" className="boy" />
            <div className="chatbot-time">{mobileTime?.toLocaleTimeString()}</div>
          </div>
          <div className="you-message fade-in">
            <div className="frame2 animated-frame"><b>{mobileNumber}</b></div>
          </div>
          <div className="chatbot animated-frame">
            <img src={bot} alt="bot" className="bot" />
            <div className="chatbot-time">{mobileTime?.toLocaleTimeString()}</div>
          </div>

          <div className="frame1 animated-frame">
            Let me know your email
            {showEmailInput && (
              <div className="message fade-in">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="input-text2"
                  value={email}
                  onChange={handleEmailChange}
                  onKeyDown={(e) => handleKeyDown(e, handleEmailSubmit)}
                  ref={emailRef}
                />
                <button className="submit-button" onClick={handleEmailSubmit}></button>
              </div>
            )}
          </div>
        </>
      )}

      {showSuccessFrame && (
        <>
          <div className="you-time animated-frame">
            <img src={you} alt="you" className="boy" />
            <div className="chatbot-time">{emailTime?.toLocaleTimeString()}</div>
          </div>
          <div className="you-message fade-in">
            <div className="frame2 animated-frame"><b>{email}</b></div>
          </div>

          <Mainmenu name={name} mobile={mobileNumber} email={email} />
        </>
      )}
    </>
  );
}

export default Frame1;
